import { writable, get } from 'svelte/store';

const store = writable({
    now: new Date()
});

// Update time
setInterval(() => {
    let state = get(store);
    let now = new Date();

    if (now.getSeconds() == state.now.getSeconds()) return;

    store.update(state => {
        state.now = now;

        return state;
    });
}, 100);

export default {
    subscribe: store.subscribe
};